import { sprintf as originalSprintf } from 'sprintf-js';

// tslint:disable-next-line no-any
export default function sprintf(str: string, ...args: any[]): string {
  try {
    return originalSprintf(str, ...args);
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') {
      // tslint:disable-next-line no-console
      console.error('i18n', e);
    }

    // return string if sprintf failed
    // It is better to display unformatted string than break js at all
    return str;
  }
}
